// Google Tag Manager loader. Idempotent: calling load() twice is safe.
// Only invoked after the user has granted consent.

const DEFAULT_GTM_ID = 'GTM-KH8NXJ7W'
const SCRIPT_ATTR = 'data-helin-gtm'
const NOSCRIPT_ATTR = 'data-helin-gtm-noscript'

interface DataLayerWindow extends Window {
  dataLayer?: Array<Record<string, unknown>>
}

export function getGtmId(): string {
  const fromEnv = (import.meta.env.VITE_GTM_ID as string | undefined)?.trim()
  return fromEnv && fromEnv.length > 0 ? fromEnv : DEFAULT_GTM_ID
}

export function isGtmLoaded(): boolean {
  return document.querySelector(`script[${SCRIPT_ATTR}]`) !== null
}

export function loadGtm(id: string = getGtmId()): void {
  if (isGtmLoaded()) return
  if (!id) return

  const w = window as DataLayerWindow
  w.dataLayer = w.dataLayer ?? []
  w.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`
  script.setAttribute(SCRIPT_ATTR, id)
  document.head.appendChild(script)

  // <noscript> fallback iframe — appended to <body> so it's covered by the
  // browser fallback when JS is blocked but consent has already been granted
  // in a prior session.
  if (!document.querySelector(`noscript[${NOSCRIPT_ATTR}]`)) {
    const noscript = document.createElement('noscript')
    noscript.setAttribute(NOSCRIPT_ATTR, id)
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(id)}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)
    document.body.appendChild(noscript)
  }
}
